import React from 'react'
import APIS from '../../constant/EndPoint'
import ComboboxInput from '../Reusable/Form/ComboboxInput'
import TextField from '../Reusable/Form/TextInput'

const StateForm = ({ errors, register, setValue, getValues, clearErrors }: any) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
      <ComboboxInput
        url={APIS.LOCATION}
        props={{ level: 0 }}
        queryKey={"country"}
        register={register("parent")}
        errors={errors?.parent}
        name={"parent"}
        label={"Country"}
        setValue={setValue}
        placeholder={"Search Country"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <TextField
        label={"Name"}
        register={register("name")}
        errors={errors?.name}
      />
    </div>
  )
}

export default StateForm
